import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemIcon,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Box,
  makeStyles,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import iconExcel from "../../../../assets/excel.png";
import iconPDF from "../../../../assets/pdf.png";
import iconWord from "../../../../assets/word.png";
import iconImage from "../../../../assets/imagen.png";
import ImageIcon from "@material-ui/icons/Image";
import DescriptionIcon from "@material-ui/icons/Description";
import CloseIcon from "@material-ui/icons/Close";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import EditIcon from "@material-ui/icons/Edit";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";

const useStyles = makeStyles((theme) => ({
  root: {
    background: "#2d3239",
    color: "#ffffff",
  },
  menu: {
    '& .MuiMenu-list': {
      background: "#2d3239",
      color: "#ffffff",
    }
  }
}));

const FileListAccordion = ({
  data,
  setFolder,
  updateFolder,
  deleteFolder,
  setFile,
  updateFile,
  deleteFile,
  openCreateFolderModal,
  handleAddFile,
  idjerarquia,
  usuario,
  permisos,
}) => {
  const classesTablero = useStylesTablero();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItemIndex, setSelectedItemIndex] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const getFileIcon = (mimeType) => {
    switch (mimeType) {
      case "application/pdf":
        return (
          <img
            src={iconPDF}
            alt="PDF Icon"
            style={{ width: "50px", height: "50px" }}
          />
        );
      case "image/jpeg":
      case "image/png":
      case "image/gif":
        return (
          <img
            src={iconImage}
            alt="Image Icon"
            style={{ width: "50px", height: "50px" }}
          />
        );
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      case "application/vnd.ms-excel":
        return (
          <img
            src={iconExcel}
            alt="Excel Icon"
            style={{ width: "50px", height: "50px" }}
          />
        );
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        return (
          <img
            src={iconWord}
            alt="Word Icon"
            style={{ width: "50px", height: "50px" }}
          />
        );
      default:
        return <DescriptionIcon />;
    }
  };

  const handleIconClick = (archivo) => {

    if (archivo?.url || archivo?.ruta) {
      // Determinar la URL
      const fileUrl = archivo.url || archivo.ruta;

      // Crear un enlace temporal
      const link = document.createElement("a");
      link.href = fileUrl;
      link.target = "_blank"; // Abrir en una nueva pestaña
      document.body.appendChild(link);

      // Simular un clic
      link.click();

      // Eliminar el enlace temporal
      document.body.removeChild(link);
    } else {
      console.error("No se encontró la URL del archivo.");
    }
  };

  const handleDelete = (itemIndex, archivoIndex) => {
    setFile(2)(archivoIndex);
  };

  const handleFileChange = (event, itemIndex) => {
    const file = event.target.files[0];
    if (file) {
      const newFile = {
        nombre: file.name,
        extension: file.name.split(".").pop(),
        direccion: URL.createObjectURL(file),
      };
      const updatedData = [...data];
      updatedData[itemIndex].archivos.push(newFile);
      setFile(1)(updatedData);
    }
  };

  const handleMenuClick = (event, index) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedItemIndex(index);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    updateFolder(data[selectedItemIndex]);
    handleCloseMenu();
  };

  const handleDeleteFromMenu = () => {
    deleteFolder(data[selectedItemIndex], data);
    handleCloseMenu();
  };

  const parseArray = (valor) => {
    if (Array.isArray(valor)) return valor;

    if (valor && typeof valor === "object") {
      let arreglo = Object.values(valor);
      return arreglo;
    }

    return null;
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "10px",
        }}
      >
        <IconButton
          id="btnCrearCarpeta"
          title="Crear carpeta"
          onClick={openCreateFolderModal}
        >
          <AddCircleIcon style={{ color: "#FFFF" }} />
        </IconButton>
      </div>

      {data?.length > 0 ? (
        data.map((item, itemIndex) => (
          <Accordion key={itemIndex} className={classesTablero.accordion}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon style={{ color: "#FFFF" }} />}
              aria-controls={`carpeta${item.idcarpeta}`}
              id={`carpeta${item.idcarpeta}`}
            >
              <Box
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography>{item.nombre}</Typography>
                <IconButton
                  title="OPCIONES"
                  id={`btnOpcionesCarpeta${item.idcarpeta}`}
                  onClick={(event) => handleMenuClick(event, itemIndex)}
                  style={{ color: "#FFFF" }}
                >
                  <MoreHorizIcon />
                </IconButton>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <List
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "nowrap",
                  overflowX: "auto",
                }}
              >
                <ListItem>
                  <IconButton
                    title="NUEVO ARCHIVO"
                    id={`btnAgregarArchivo${item?.idcarpeta}`}
                    onClick={() => handleAddFile(item)}
                    edge="end"
                    style={{ marginLeft: "20px" }}
                  >
                    <AddIcon style={{ color: "#FFFF" }} />
                  </IconButton>
                </ListItem>
                {item?.archivos &&
                  parseArray(item?.archivos)?.map((archivo, archivoIndex) => {
                    if (archivo?.idestatus == 1) {
                      return (
                        <ListItem
                          title={archivo?.nombre}
                          id={`btnArchivo${archivo?.idarchivo}`}
                          key={archivoIndex}
                          style={{
                            display: "flex",
                            position: "relative",
                            marginRight: "20px",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <IconButton
                            id={`btnDescargarArchivo${archivo?.idarchivo}`}
                            onClick={() => handleIconClick(archivo)}
                            edge="end"
                            style={{
                              marginLeft: "24px",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }} // Alineamos los elementos verticalmente
                          >
                            <ListItemIcon style={{ justifyContent: "center" }}>
                              {getFileIcon(archivo.mimeType)}
                            </ListItemIcon>
                          </IconButton>

                          <IconButton
                            title={`ELIMINAR ARCHIVO`}
                            id={`btnEliminarArchivo${archivo?.idarchivo}`}
                            onClick={() => deleteFile(archivo, data)}
                            style={{
                              position: "absolute",
                              top: "0",
                              right: "0",
                              padding: "4px",
                              color: "#FFFF",
                            }}
                            disabled={
                              !(
                                idjerarquia == 2 ||
                                [2, 3].includes(usuario[0]?.idrol)
                              )
                            }
                          >
                            <CloseIcon />
                          </IconButton>

                          {/* <Typography
                            variant="caption"
                            style={{ textAlign: "center", marginTop: "4px" }}
                          >
                            {archivo?.nombre}
                          </Typography> */}
                        </ListItem>
                      );
                    }
                  })}
              </List>

              <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
                className={classesTablero.menu}
              >
                <MenuItem
                  id="btnEditar"
                  onClick={handleEdit}
                  disabled={
                    !(idjerarquia == 2 || [2, 3].includes(usuario[0]?.idrol))
                  }
                >
                  <ListItemIcon>
                    <EditIcon style={{ color: "#FFFF" }} />
                  </ListItemIcon>
                  Editar
                </MenuItem>
                <MenuItem
                  id="btnEliminar"
                  onClick={handleDeleteFromMenu}
                  disabled={
                    !(idjerarquia == 2 || [2, 3].includes(usuario[0]?.idrol))
                  }
                >
                  <ListItemIcon>
                    <DeleteIcon style={{ color: "#FFFF" }} />
                  </ListItemIcon>
                  Borrar
                </MenuItem>
              </Menu>
            </AccordionDetails>
          </Accordion>
        ))
      ) : (
        <Typography variant="body1" color="textSecondary">
          No hay documentación disponible para este proyecto
        </Typography>
      )}
    </div>
  );
};

export default FileListAccordion;
